const messages = {
  'collection.group.high': 'High stool',
  'collection.group.low': 'Counter stool',
  'collection.group.cloverleaf': 'Cloverleaf',
  'collection.group.base': 'Base',
  'collection.about' : 'A proposito di {name}',
  'collection.buyNow' : 'Acquista ora',
  'collection.customize': 'Configura il prodotto',
  'collection.from' : 'A partire da €{value}',
  'collection.findOutMore' : 'Scopri di più',
  'collection.otherArtists' : 'Designer che hanno partecipato',
  'contact.agents.title': 'Agenti',
  'contact.onlineShops.title': 'Negozi online',
  'contact.distributors.address': 'Indirizzo',
  'contact.distributors.country': 'Nazione',
  'contact.distributors.name': 'Nome',
  'contact.distributors.phoneNumber': 'Contatto telefonico',
  'contact.distributors.title': 'Distributori',
  'contact.distributors.visitShop': 'Visita lo shop',
  'designersPage.artists': 'Artisti',
  'flash.dismiss': 'Chiudi',
  'footer.contact.faxNumber': 'Fax:',
  'footer.contact.phoneNumber': 'Telefono:',
  'footer.cta.button': 'Contattaci',
  'footer.cta.title': 'Vuoi saperne di più?',
  'form.collection': 'Collezione',
  'form.company': 'Azienda',
  'form.country': 'Paese',
  'form.email': 'Email',
  'form.job': 'Tipologia cliente',
  'form.job.architect': 'Architetto',
  'form.job.company': 'Azienda',
  'form.job.journalist': 'Giornalista',
  'form.job.other': 'Altro',
  'form.job.private': 'Cliente privato',
  'form.job.retailer': 'Retailer',
  'form.message': 'Messaggio',
  'form.name': 'Il tuo nome',
  'form.phoneNumber': 'Contatto telefonico',
  'form.product': 'Prodotto',
  'form.price': 'Prezzo',
  'form.sku': 'Codice prodotto SKU',
  'form.newsletter': 'Iscriviti alla nostra newsletter',
  'form.iHaveRead': 'Ho letto la normativa di ',
  'form.privacy': ' privacy',
  'home.collection': 'Collezione',
  'home.designBy': 'Design di',
  'home.discoverCollection': 'Scopri Collezione',
  'news.categories': 'Categorie',
  'philosophy.customize': 'Crea la tua sedia!',
  'requestContactForm.button': 'Richiedi informazioni',
  'requestContactForm.error': 'Non è stato possibile inviare la richiesta di informazioni, perfavore controlla gli errori',
  'requestContactForm.success': 'La richiesta di informazioni è stata inviata correttamente',
  'requestInfoForm.button': 'Richiedi informazioni',
  'requestInfoForm.description': 'Inviaci una nota e ti risponderemo il prima possibile.',
  'requestInfoForm.error': 'Non è stato possibile inviare la richiesta di informazioni, perfavore controlla gli errori',
  'requestInfoForm.success': 'La richiesta di informazioni è stata inviata correttamente',
  'requestInfoForm.title': 'Richiedi informazioni',

  'newsletterForm.button': 'Iscriviti',
  'newsletterForm.description': 'Iscriviti alla nostra newsletter.',
  'newsletterForm.error': 'Non è stato possibile inviare la richiesta di iscrizione alla newsletter',
  'newsletterForm.success': 'Grazie per la tua sottoscrizione!',

  'requestModelForm.button': 'Inviami i modelli 3D via email',
  'requestModelForm.description': 'Perfavore, compila le seguenti informazioni e riceverai via email un link per scaricare i modelli 3D.',
  'requestModelForm.title': 'Richiedi modello 3D',
  'requestModelForm.error': 'Non è stato possibile inviare il modello 3D, perfavore controlla gli errori',
  'requestModelForm.success': 'Il modello 3D è stato correttamente inviato via email',
  'requestDownloadAccess.button': 'Inviami il link via mail',
  'requestDownloadAccess.description': "Perfavore, compila le seguenti informazioni e riceverai via email il link per accedere nell'area download",
  'requestDownloadAccess.title': 'Richiedi link a download area',
  'requestDownloadAccess.error': 'Non è stato possibile inviare la mail, perfavore controlla gli errori',
  'requestDownloadAccess.success': "Il link di accesso all'area download è stato correttamente inviato via email",
  'workTable.manual': 'Manuale instruzioni',
  'workTable.request3dModel': 'Richiedi modello 3D',
  'workTable.requestInformation': 'Richiedi informazioni',
  'workTable.iWantThis': 'I want this ❤',
  'workTable.share': 'Condividi su Facebook',
  'workTable.sheet': 'Data sheet',
  'workTable.accessories': 'Accessori',
  'noContent': 'Non ci sono risultati per questa ricerca',
  'notFound.title': 'Pagina non trovata',
  'notFound.text': 'La pagina che cerchi non è disponibile, già che ci sei dai un\'occhiata al nostro catalogo!',
  'iubendaId': '91142549',

};

export default messages;



// WEBPACK FOOTER //
// ./src/locales/it.js